var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright 2022 The Parca Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import { useState } from 'react';
import { Icon } from '@iconify/react';
import useUIFeatureFlag from '@parca/functions/useUIFeatureFlag';
import { USER_PREFERENCES } from '@parca/functions/useUserPreference';
import { Button, IconButton, Modal } from '../';
import FlamegraphColorProfileSelector from './FlamegraphColorProfileSelector';
import UserPreferenceItem from './UserPreferenceItem';
var FlagToggle = function (_a) {
    var name = _a.name, id = _a.id;
    var _b = useUIFeatureFlag(id), enabled = _b[0], setEnabled = _b[1];
    return (_jsxs("div", __assign({ className: "flex gap-2" }, { children: [_jsx("input", { type: "checkbox", id: id, checked: enabled, onChange: function (e) { return setEnabled(e.target.checked); } }), _jsx("label", __assign({ htmlFor: id }, { children: name }))] })));
};
var UserPreferences = function () {
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    return (_jsxs("div", { children: [_jsx(IconButton, __assign({ onClick: function () { return setIsOpen(!isOpen); } }, { children: _jsx(Icon, { icon: "material-symbols:settings-outline-rounded", fontSize: 20 }) })), _jsxs(Modal, __assign({ isOpen: isOpen, closeModal: function () {
                    setIsOpen(false);
                }, title: "Preferences", className: "max-w-[460px]" }, { children: [_jsxs("div", __assign({ className: "min-h-40 mt-8" }, { children: [_jsx(UserPreferenceItem, { userPreferenceDetails: USER_PREFERENCES.HIGHTLIGHT_AFTER_FILTERING }), _jsx(UserPreferenceItem, { userPreferenceDetails: USER_PREFERENCES.ENABLE_GRAPH_TRIMMING }), _jsx(FlamegraphColorProfileSelector, {}), _jsxs("div", __assign({ className: "min-w-96 mt-10" }, { children: [_jsx("h4", __assign({ className: "font-medium mb-2" }, { children: "Experimental Features" })), _jsx(FlagToggle, { name: "Enable Callgraph", id: "callgraph" })] }))] })), _jsx("div", __assign({ className: "flex justify-end" }, { children: _jsx(Button, __assign({ onClick: function () { return setIsOpen(false); }, className: "w-fit" }, { children: "Close" })) }))] }))] }));
};
export default UserPreferences;
